import { render, staticRenderFns } from "./PushPreview.vue?vue&type=template&id=0ccba418&scoped=true"
import script from "./PushPreview.vue?vue&type=script&lang=js"
export * from "./PushPreview.vue?vue&type=script&lang=js"
import style0 from "./PushPreview.vue?vue&type=style&index=0&id=0ccba418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccba418",
  null
  
)

export default component.exports